import React from 'react';
import { Link } from 'react-router-dom';

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_58284b88-53d8-4c2d-a757-f70994c6780a/artifacts/yxcl41jr_17fb61916fadfcb65ccf78419aa879e3f44d8d6b4289b01fdfd0f1c53d7537c0.png";

const Footer = () => {
  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-gray-300 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <img 
                src={LOGO_URL} 
                alt="ConstructHelp" 
                className="h-16 w-auto brightness-110"
              />
            </Link>
            <p className="text-gray-400 text-sm">
              Connecting construction professionals with opportunities nationwide.
            </p>
          </div>

          {/* Browse */}
          <div>
            <h4 className="text-white font-semibold mb-4">Browse</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/find-workers" className="text-gray-400 hover:text-white transition-colors">
                  Find Workers
                </Link>
              </li>
              <li>
                <Link to="/browse-jobs" className="text-gray-400 hover:text-white transition-colors">
                  Browse Jobs
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-400 hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/home" data-testid="footer-features-link" className="text-gray-400 hover:text-white transition-colors">
                  Features & Tools
                </Link>
              </li>
              <li>
                <Link to="/timeline" data-testid="footer-timeline-link" className="text-gray-400 hover:text-white transition-colors">
                  What's New
                </Link>
              </li>
              <li>
                <Link to="/tools/construction-voice-translator" className="text-gray-400 hover:text-white transition-colors">
                  Voice Translator
                </Link>
              </li>
              <li>
                <Link to="/tools/concrete-calculator" data-testid="footer-concrete-calc-link" className="text-gray-400 hover:text-white transition-colors">
                  Concrete Calculator
                </Link>
              </li>
              <li>
                <Link to="/tools/ai-crew-scheduling" className="text-gray-400 hover:text-white transition-colors">
                  AI Crew Scheduling
                </Link>
              </li>
              <li>
                <Link to="/tools/escrow-payment-protection" className="text-gray-400 hover:text-white transition-colors">
                  Escrow Protection
                </Link>
              </li>
              <li>
                <Link to="/guides" data-testid="footer-guides-link" className="text-gray-400 hover:text-white transition-colors">
                  Cost Guides
                </Link>
              </li>
              <li>
                <Link to="/blog" data-testid="footer-blog-link" className="text-gray-400 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/tutorials" data-testid="footer-tutorials-link" className="text-gray-400 hover:text-white transition-colors">
                  Tutorials
                </Link>
              </li>
              <li>
                <Link to="/store" data-testid="footer-store-link" className="text-gray-400 hover:text-white transition-colors">
                  Tool Store
                </Link>
              </li>
              <li>
                <Link to="/trust" data-testid="footer-trust-link" className="text-gray-400 hover:text-white transition-colors">
                  Trust Center
                </Link>
              </li>
            </ul>
          </div>

          {/* Hire a Pro */}
          <div>
            <h4 className="text-white font-semibold mb-4">Hire a Pro</h4>
            <ul className="space-y-2">
              {[
                ['/hire/roofers', 'Hire a Roofer'],
                ['/hire/plumbers', 'Hire a Plumber'],
                ['/hire/electricians', 'Hire an Electrician'],
                ['/hire/remodeling-contractors', 'Remodeling Contractors'],
                ['/hire/painters', 'Hire a Painter'],
                ['/hiring-guides', 'Hiring Guides'],
                ['/advertising', 'Advertise With Us'],
                ['/hire', 'All Trades'],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-gray-400 hover:text-white transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2024 ConstructHelp. All rights reserved. Free to join • No setup fees • Start connecting today
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
